import { Injectable } from '@angular/core';
declare var swal: any;

@Injectable()
export class ToastService {
  success(message: string): Promise<any> {
    return swal({
      text: message,
      type: 'success',
      timer: 1500,
      showConfirmButton: false,
      customClass: 'swal-custom swal-success'
    });
  }

  error(message: string): Promise<any> {
    return swal({
      text: message,
      type: 'error',
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#b8465e',
      customClass: 'swal-custom swal-error'
    });
  }

  errorWithAction(
    message: string,
    confirmButtonText: string,
    cancelButtonText = 'Cancelar'
  ): Promise<any> {
    return swal({
      text: message,
      type: 'error',
      showCancelButton: true,
      confirmButtonText,
      cancelButtonText,
      confirmButtonColor: '#b8465e',
      cancelButtonColor: '#999',
      customClass: 'swal-custom swal-error'
    });
  }

  warning(message: string, title?: string): Promise<any> {
    return swal({
      title: title || '',
      text: message,
      type: 'warning',
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#b8465e',
      customClass: 'swal-custom swal-warning'
    });
  }

  confirm(
    title: string,
    text: string,
    confirmButtonText = 'Aceptar',
    cancelButtonText = 'Cancelar'
  ): Promise<any> {
    return swal({
      title,
      text,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#b8465e',
      cancelButtonColor: '#999',
      confirmButtonText,
      cancelButtonText,
      customClass: 'swal-custom swal-warning'
    });
  }

  confirmWithReason(
    title: string,
    text: string,
    confirmButtonText = 'Aceptar',
    cancelButtonText = 'Cancelar',
    maxLength = 500
  ): Promise<any> {
    return swal({
      title,
      text,
      type: 'warning',
      customClass: 'swal-custom swal-reason',
      showCancelButton: true,
      confirmButtonText,
      cancelButtonText,
      confirmButtonColor: '#b8465e',
      input: 'textarea',
      inputPlaceholder: 'Motivo...',
      inputAttributes: {
        maxlength: maxLength.toString()
      },

      onOpen: () => {
        const textarea = swal.getInput() as HTMLTextAreaElement;

        const counter = document.createElement('div');
        counter.textContent = `0 / ${maxLength}`;
        counter.className = 'swal-counter';

        textarea.insertAdjacentElement('afterend', counter);

        textarea.addEventListener('input', () => {
          const length = textarea.value.length;
          counter.textContent = `${length} / ${maxLength}`;
          counter.classList.toggle('limit', length >= maxLength);
        });
      },

      onClose: () => {
        const counter = document.querySelector('.swal-counter');

        if (counter) {
          counter.remove();
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/app/services/toast.service.ts